import { render, staticRenderFns } from "./PaymentReceivableFunction.vue?vue&type=template&id=3b343c97"
import script from "./PaymentReceivableFunction.vue?vue&type=script&lang=js"
export * from "./PaymentReceivableFunction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports